const initialState = {
    savingFirstSurvey: false,
    surveySaveSuccess: false,
    surveySaveError: false,
    savingDailyBaseLineLoader: false,
    savingDailyBaseLineSuccess: false,
    savingDailyBaseLineError: false

}

export default (state = initialState, action) => {
    switch (action.type) {
        case "updatingDailyBaseLine_START": {
            return { ...state, savingDailyBaseLineLoader: true }
        }
        case "updateDailyBaseLine_SUCCESS": {
            return { ...state, savingDailyBaseLineLoader: false, savingDailyBaseLineSuccess: true }
        }
        case "updateDailyBaseLine_FAILURE": {
            return { ...state, savingDailyBaseLineLoader: false, savingDailyBaseLineError: true }
        }
        case "savingSurveyInfo_START":
            return { ...state, savingFirstSurvey: true }
        case "saveCustomerSurvey_SUCCESS":
            return { ...state, surveySaveSuccess: true, savingFirstSurvey: false }
        case "saveCustomerSurvey_FAILURE":
            return { ...state, surveySaveError: true, savingFirstSurvey: false }

        case 'reset_survey':
            return {
                ...state,
                savingFirstSurvey: false,
                surveySaveSuccess: false,
                surveySaveError: false,
                savingDailyBaseLineLoader: false,
                savingDailyBaseLineSuccess: false,
                savingDailyBaseLineError: false
            }

        default:
            return state
    }
}
